{
  "allocation_of_full_seats": "Verdeling van de volle zetels",
  "allocation_of_residual_seats": "Verdeling van de restzetels",
  "all_seats_assigned": "Alle zetels zijn toegewezen",
  "already_assigned": "Reeds toegewezen",
  "apportionment_already_calculated": "De zetelverdeling is al berekend.",
  "assigned_by_drawing_lots_alert": {
    "singular": "Restzetel {nr} kon niet automatisch worden toegewezen en is na loting toegekend aan <strong>{list}</strong> (er is geloot tussen lijst {options}).",
    "plural": {
      "title": "Sommige restzetels konden niet automatisch worden toegewezen en zijn via loting toegekend:",
      "assigned_to": "Restzetel {nr} is toegekend aan <strong>{list}</strong>\n(er is geloot tussen lijst {options})"
    }
  },
  "assigned_by_drawing_lots_to_candidate_alert": {
    "singular": "Zetel {seat_number} is na loting toegewezen aan <strong>{candidate}</strong> (er is geloot tussen kandidaat {options})",
    "plural": {
      "title": "Sommige zetels konden niet automatisch worden toegewezen en zijn via loting toegekend:",
      "assigned_to": "Zetel {seat_number} is toegewezen aan <strong>{candidate}</strong>\n(er is geloot tussen kandidaat {options})"
    }
  },
  "assigned_number_of_seats": "Toegewezen aantal zetels",
  "average": "Gemiddelde",
  "average_number": "gemiddeld aantal",
  "averages_per_list": "Gemiddelden per lijst (na toekennen restzetel)",
  "below_candidates_are_deceased": "Onderstaande kandidaten zijn als gevolg van overlijden bij de zetelverdeling buiten beschouwing gelaten.",
  "candidates_for_apportionment": "Kandidaten voor zetelverdeling",
  "chosen_candidates": "Gekozen kandidaten",
  "data_entry_finished": "Invoerfase afgerond",
  "details_residual_seats_allocation": "Details restzetelverdeling",
  "drawing_lots": "Loting",
  "drawing_lots_for_candidate": {
    "title": "Loting voor kandidaten met evenveel stemmen",
    "candidates_for_drawing_lots": "Er zijn {num_candidates} kandidaten die op basis van hun voorkeursstemmen in aanmerking komen voor zetel {seat_number}. Zij hebben allen {votes} stemmen. Het gaat om de kandidaten:",
    "hence_drawing_lots_is_needed": "Daarom moet er geloot worden wie zetel {seat_number} krijgt.",
    "total_seats": {
      "singular": "{list} heeft {total_seats} zetel.",
      "plural": "{list} heeft {total_seats} zetels."
    }
  },
  "drawing_lots_for_list": {
    "title": "Loting voor restzetel {number}",
    "hence_drawing_lots_is_needed": "Daarom moet er geloot worden welke lijst de restzetel krijgt.",
    "list_gets_the_seat_with": {
      "highest_average": "De partij met het hoogste gemiddeld aantal stemmen bij het toewijzen van de restzetel krijgt de restzetel.",
      "largest_remainder": "De partij met het grootste overschot aan stemmen krijgt de restzetel."
    },
    "draw_lots_for_lists_with_same": {
      "highest_average": "<strong>{lists}</strong> hebben ieder het hoogste gemiddeld aantal stemmen per zetel ({value} stemmen).",
      "largest_remainder": "<strong>{lists}</strong> hebben ieder het grootste overschot ({value} stemmen)."
    },
    "residual_seats_to_assign": {
      "singular": "Er is {nr} restzetel te verdelen.",
      "plural": "Er zijn {nr} restzetels te verdelen."
    },
    "seat_cannot_be_assigned_automatically": "Restzetel {nr} kan niet automatisch worden toegewezen."
  },
  "drawing_lots_for_p9": {
    "title": "Loting voor afstaan restzetel aan lijst {assign_to}",
    "hence_drawing_lots_is_needed": "Daarom moet er geloot worden welke lijst de restzetel moet afstaan.",
    "last_residual_seat_to_list": "De laatste restzetel moet worden afgestaan aan lijst {nr}.",
    "list_got_absolute_majority": "Lijst {nr} heeft de volstrekte meerderheid van stemmen gekregen, maar heeft niet de volstrekte meerderheid aan zetels.",
    "lists_got_last_residual_seats": "Lijst {lists} hebben met hetzelfde {variant} stemmen de laatste restzetels gekregen."
  },
  "drawing_lots_instructions": {
    "title": "Instructies voor loting",
    "description": "De loting vindt buiten Abacus plaats, in aanwezigheid van alle leden van het centraal stembureau. Waarnemers mogen meekijken. Voer het resultaat hieronder in."
  },
  "drawing_lots_necessary": "Loting noodzakelijk",
  "drawing_lots_needed": "Loting nodig",
  "drawing_lots_required_for_candidates_alert": {
    "title": "Loting noodzakelijk voor kandidaten met gelijk aantal voorkeursstemmen",
    "description": {
      "singular": "{num_candidates} kandidaten van {list} hebben evenveel voorkeursstemmen gekregen. Er is nog {num_seats} zetel beschikbaar. In de Kieswet staat dat de kandidaat met het hoogste aantal voorkeursstemmen de zetel krijgt.",
      "plural": "{num_candidates} kandidaten van {list} hebben evenveel voorkeursstemmen gekregen. Er zijn nog {num_seats} zetels beschikbaar. In de Kieswet staat dat de kandidaten met het hoogste aantal voorkeursstemmen de zetels krijgen."
    },
    "drawing_lots_needed": {
      "singular": "Hierdoor kan de zetel niet automatisch worden toegewezen. Het centraal stembureau moet een loting uitvoeren om te bepalen welke kandidaat gekozen wordt.",
      "plural": "Hierdoor kunnen de zetels niet automatisch worden toegewezen. Het centraal stembureau moet een loting uitvoeren om te bepalen welke kandidaten gekozen worden."
    }
  },
  "drawing_lots_required_for_list_alert": {
    "title": {
      "singular": "Loting noodzakelijk voor toekennen restzetel",
      "plural": "Loting noodzakelijk voor toekennen restzetels"
    },
    "description": "Er is een restzetel te verdelen. In de Kieswet staat dat de partij met het grootste {variant} stemmen per toegewezen zetel deze restzetel krijgt.",
    "drawing_lots_needed": "Hierdoor kan de restzetel niet automatisch worden toegewezen. Het centraal stembureau moet een loting uitvoeren om de restzetel toe te wijzen.",
    "same_averages": "Er zijn meerdere partijen die bij het toewijzen van de volgende restzetel precies hetzelfde hoogste gemiddelde hebben.",
    "same_remainders": "Er zijn meerdere partijen die hetzelfde grootste overschot hebben."
  },
  "drawing_lots_required_for_p9_alert": {
    "title": "Loting noodzakelijk vanwege volstrekte meerderheid",
    "article_p9": "Volgens artikel P 9 van de Kieswet wordt een zetel afgenomen van de lijst die een zetel heeft gekregen op basis van het kleinste {variant} stemmen.",
    "description": "{name} heeft de volstrekte meerderheid van stemmen gekregen, maar heeft niet de volstrekte meerderheid aan zetels.",
    "drawing_lots_needed": "In de zitting van het CSB moet door loting worden bepaald welke van deze lijsten een zetel af moet staan.",
    "last_residual_seat": "<strong>Lijst {lists}</strong> hebben met hetzelfde {variant} stemmen hun zetels gekregen."
  },
  "drawing_lots_result": {
    "title": "Resultaat loting",
    "which_candidate_gets_the_seat": "Welke kandidaat krijgt de zetel?",
    "which_list_gets_a_residual_seat": "Welke partij krijgt de restzetel?",
    "which_list_has_to_give_up_a_seat": "Welke partij moet een restzetel afstaan?"
  },
  "election_summary": "Kengetallen",
  "footnotes": {
    "absolute_majority_reassignment": {
      "drawing_lots": "Lijst {options} moet een restzetel afstaan. Hiervoor moet geloot worden.",
      "options": " (er is geloot tussen lijst {options})",
      "result": "Deze zetel gaat ten koste van lijst {list_retracted_seat}",
      "text": "Lijst {list_assigned_seat} heeft meer dan de helft van alle uitgebrachte stemmen behaald, maar krijgt op basis van de standaard zetelverdeling niet de meerderheid van de zetels. Volgens de Kieswet (Artikel P 9 Toewijzing zetels bij volstrekte meerderheid) krijgt deze lijst één extra zetel."
    },
    "article_p10": "(Kieswet, artikel P 10)",
    "full_seat_removed_remainder_information": "Het overschot is berekend op basis van de {num_full_seats} volle zetels die de lijst heeft gehaald voordat lijstuitputting is meegenomen (Kieswet, artikel P 8).",
    "list_exhaustion_full_seat_removal": "Omdat lijst {list_retracted_seat} onvoldoende kandidaten heeft, is één volle zetel herverdeeld als restzetel.",
    "list_exhaustion_residual_seat_removal": "Omdat lijst {list_retracted_seat} geen kandidaat heeft voor een zetel, is deze herverdeeld naar een andere lijst."
  },
  "full_seat": {
    "singular": "Volle zetel",
    "plural": "Volle zetels"
  },
  "full_seats_count": "Aantal volle zetels",
  "full_seats_information": "Per politieke groepering wordt berekend hoe vaak de kiesdeler in het aantal stemmen past. Het resultaat van deze deling geeft het aantal volle zetels dat is behaald.",
  "full_seats_information_link": {
    "singular": "Na het <link>verdelen van de volle zetels</link> is er nog {num_residual_seats} restzetel.",
    "plural": "Na het <link>verdelen van de volle zetels</link> zijn er nog {num_residual_seats} restzetels."
  },
  "go_to_drawing_lots": "Ga naar loting",
  "how_many_residual_seats": "Hoeveel restzetels zijn er te verdelen?",
  "how_often_is_quota_met": "Hoe vaak haalde elke partij de kiesdeler?",
  "in_alphabetical_order": "In alfabetische volgorde",
  "include_all_candidates": {
    "description": "Voordat de zetelverdeling kan worden uitgevoerd, is het belangrijk dat de kandidatenlijst volledig en correct is. Kandidaten die zijn overleden worden niet meegenomen bij het verdelen van de zetels. Stemmen op de overleden kandidaat tellen wel mee als stemmen op diens partij. Dat staat zo in de Kieswet.",
    "has_deceased": "Eén of meerdere kandidaten zijn overleden",
    "no_deceased": "Er zijn geen overleden kandidaten",
    "title": "Zijn er overleden kandidaten?"
  },
  "indicate_deceased_candidate": "Geef aan welke kandidaat of kandidaten als gevolg van overlijden bij de zetelverdeling buiten beschouwing moeten worden gelaten.",
  "information_highest_averages": "Er zijn 19 of meer zetels. Daarom worden restzetels toegewezen volgens het <strong>systeem van de grootste gemiddelden</strong>. De partij die na toewijzing van een restzetel het hoogste aantal stemmen per zetel heeft, krijgt de restzetel.\nIn de tabel is het gemiddeld aantal stemmen per zetel te vinden dat elke lijst zou krijgen als een restzetel zou worden toegekend.",
  "information_largest_remainders": "Er zijn minder dan 19 zetels. Daarom worden restzetels toegewezen volgens het <strong>systeem van de grootste overschotten</strong>. De restzetels zijn één voor één toegewezen aan de lijsten die na verdeling van de zetels het grootste overschot aan stemmen hebben. Hierbij heeft iedere lijst niet meer dan één zetel toegewezen gekregen. Lijsten die minder dan 75% van de kiesdeler hebben gehaald, komen niet in aanmerking voor een restzetel.",
  "list_assigned_nr_seats": {
    "singular": "{list_name} heeft <strong>{num_seats} zetel</strong> toegewezen gekregen.",
    "plural": "{list_name} heeft <strong>{num_seats} zetels</strong> toegewezen gekregen."
  },
  "list_details_alert": {
    "deceased_candidate": "Kandidaat {nr} is buiten beschouwing gelaten bij het verdelen van de zetels vanwege overlijden.",
    "deceased_candidates": "Kandidaten {nrs} zijn buiten beschouwing gelaten bij het verdelen van de zetels vanwege overlijden.",
    "votes_have_been_counted_on_the_list": "Stemmen op overleden kandidaten zijn wel meegeteld als stemmen op diens lijst."
  },
  "lists_a_seat_needs_to_be_reassigned_for": "Lijst {seat_from_lists} moet een zetel afstaan aan lijst {seat_to_list}.",
  "make_apportionment_definitive": "Je kunt de zetelverdeling nu definitief maken en het proces-verbaal downloaden.",
  "manage_deceased_candidates": "Beheer overleden kandidaten",
  "minus": "min",
  "no_candidates_are_deceased": "Alle kandidaten zijn meegenomen bij het verdelen van de zetels. Er zijn geen kandidaten buiten beschouwing gelaten vanwege overlijden.",
  "not_possible": "Zetelverdeling is niet mogelijk",
  "not_yet_assigned": "Nog niet toegewezen",
  "not_yet_available": "Zetelverdeling is nog niet beschikbaar",
  "no_residual_seats_to_assign": "Er zijn geen restzetels te verdelen.",
  "number_of_seats": "Aantal raadszetels",
  "other_chosen_candidates": "Kandidaten die gekozen zijn vanwege hun positie op de lijst",
  "other_chosen_candidates_empty": "Geen enkele kandidaat is zonder voorkeursstemmen gekozen.",
  "other_chosen_candidates_info": "Deze kandidaten hebben zelfstandig niet voldoende stemmen gehaald voor een zetel, maar hebben een zetel toegewezen gekregen vanwege hun positie op de lijst.",
  "position_on_list": "Positie op lijst",
  "preference_threshold": "Voorkeursdrempel",
  "preference_threshold_description": "{percentage}% van de kiesdeler",
  "preferentially_chosen_candidates": "Met voorkeursstemmen gekozen kandidaten",
  "preferentially_chosen_candidates_empty": "Geen van de kandidaten heeft meer dan {percentage}% van de kiesdeler gehaald. Niemand is met voorkeursstemmen gekozen.",
  "preferentially_chosen_candidates_info": "De volgende kandidaten zijn met voorkeursstemmen gekozen. Deze kandidaten hebben meer dan {percentage}% van de kiesdeler gehaald.",
  "preliminary_result": "Voorlopig resultaat",
  "quota": "Kiesdeler",
  "quota_description": "Benodigde stemmen per volle zetel",
  "rank": "Rang",
  "ranking_candidates": "Rangschikking van kandidaten voor opvolging",
  "ranking_candidates_empty": "Geen enkele kandidaat is niet gekozen.",
  "ranking_candidates_info": "De volgende kandidaten hebben geen zetel toegewezen gekregen. Als een zetel vrijkomt wordt deze via de onderstaande volgorde aan opvolgers toegewezen.",
  "reassigned_by_drawing_lots_alert": "De laatste restzetel voor lijst {assigned_to} (artikel P 9) is na loting afgestaan door <strong>{retracted_from}</strong> (er is geloot tussen lijst {options})",
  "redo_apportionment": "Doe dan de zetelverdeling opnieuw",
  "redo_apportionment_button": "Zetelverdeling opnieuw doen",
  "remainder": "Overschot",
  "remainder_of": "overschot aan",
  "remaining_residual_seats_assignment": "Verdeling overige restzetels",
  "remaining_residual_seats_amount_and_information": {
    "singular": "Hierna was er nog {num_seats} restzetel te verdelen. Deze zetel is toegewezen aan de lijst die met een zetel erbij het grootste gemiddelde aantal stemmen per zetel zou hebben.",
    "plural": "Hierna waren er nog {num_seats} restzetels te verdelen. Deze zetels zijn toegewezen aan de lijsten die met een zetel erbij het grootste gemiddelde aantal stemmen per zetel zouden hebben.",
    "plural_unique": "Hierna waren er nog {num_seats} restzetels te verdelen. Deze zetels zijn toegewezen aan de lijsten die met een zetel erbij het grootste gemiddelde aantal stemmen per zetel zouden hebben. Hierbij heeft iedere lijst niet meer dan één zetel toegewezen gekregen."
  },
  "residual_seat": {
    "singular": "Restzetel",
    "plural": "Restzetels"
  },
  "residual_seat_assigned_to_list": "Restzetel toegekend aan lijst",
  "residual_seats_count": "Aantal restzetels",
  "residual_seats_information_amount_and_link": {
    "singular": "Er is <link>{num_residual_seats} restzetel te verdelen</link>.",
    "plural": "Er zijn <link>{num_residual_seats} restzetels te verdelen</link>."
  },
  "residual_seats_information_highest_averages": "Omdat het totaal aantal zetels groter is dan of gelijk is aan 19, gebeurt dat via het systeem van de grootste gemiddelden.",
  "residual_seats_information_largest_remainders": "Omdat het totaal aantal zetels kleiner is dan 19, gebeurt dat via het systeem van de grootste overschotten.",
  "residual_seats_highest_averages": "De restzetels gaan naar de partijen met de grootste gemiddelden",
  "residual_seats_largest_remainders": "De restzetels gaan naar de partijen met de grootste overschotten",
  "round": "Ronde",
  "seat": "Zetel",
  "seat_needs_to_be_retracted": "Er moet 1 restzetel worden afgestaan.",
  "seats_assigned": {
    "singular": "{num_seat} zetel werd als {type_seat} toegewezen",
    "plural": "{num_seat} zetels werden als {type_seat} toegewezen"
  },
  "seats_left_to_assign": {
    "singular": "Er is nog {num_seat} restzetel te verdelen.",
    "plural": "Er zijn nog {num_seat} restzetels te verdelen."
  },
  "title": "Zetelverdeling",
  "to_apportionment": "Naar zetelverdeling",
  "to_drawing_lots": "Naar loting",
  "total": "Totaal",
  "total_number_assigned_full_seats": "Totaal aantal toegewezen volle zetels",
  "total_number_seats": "Totaal aantal zetels",
  "total_number_votes_per_candidate": "Totaal aantal stemmen per kandidaat",
  "total_seats": "Totaal zetels",
  "total_votes_cast_count": "Getelde stembiljetten",
  "turnout": "Opkomst",
  "view_details": "Bekijk details",
  "voters": "Kiesgerechtigden",
  "want_to_make_changes": "Wil je wijzigingen aanbrengen in de buiten beschouwing gelaten kandidaten?",
  "warning": {
    "absolute_majority_and_list_exhaustion": "Zowel art. P 9 (volstrekte meerderheid) als art. P 10 (lijstuitputting) van de Kieswet zijn toegepast tijdens het berekenen van de zetelverdeling. Neem contact op met de Kiesraad om te overleggen of er extra controles nodig zijn.",
    "not_all_seats_assigned": "Niet alle zetels zijn toegewezen."
  },
  "which_candidates_are_deceased": "Geef aan welke kandidaat of kandidaten als gevolg van overlijden bij de zetelverdeling buiten beschouwing moeten worden gelaten."
}
